export { TableOfContents } from './TableOfContent';
